module.exports = __webpack_public_path__ + "static/media/Avatars_Other-01.dbfdef3f.png";